window.CustomAccordion ||= class extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector("details");
    this.summary = this.details.querySelector("summary");
    this.summary.addEventListener("click", this.onSummaryClick.bind(this));
  }

  onSummaryClick(ev) {
  }

  open() {
    this.details.setAttribute("open", "open");
  }

  close() {
    this.details.removeAttribute("open");
  }

  toggle() {
    (this.details.open)
      ? this.close()
      : this.open();
  }
}

window.MobileAccordion ||= class extends CustomAccordion {
  constructor() {
    super();

    window.breakpoints.mobile.addEventListener(
      "change",
      this.onMediaQueryChange.bind(this)
    );
    this.onMediaQueryChange(window.breakpoints.mobile);
  }

  onMediaQueryChange(query) {
    if (query.matches) {
      this.close();
    } else {
      this.open();
    }
  }

  onSummaryClick(ev) {
    if (window.breakpoints.mobile.matches) return;

    this.toggle();
  }
}

if (customElements.get("custom-accordion") === undefined) {
  customElements.define("custom-accordion", CustomAccordion);
  customElements.define("mobile-accordion", MobileAccordion);
}